/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 3H6.4C5.55992 3 5.13988 3 4.81901 3.16349C4.53677 3.3073 4.3073 3.53677 4.16349 3.81901C4 4.13988 4 4.55992 4 5.4V9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 12H15.5C17.9853 12 20 14.0147 20 16.5V16.5C20 18.9853 17.9853 21 15.5 21H5.77778C4.79594 21 4 20.2041 4 19.2222V12ZM4 12H12.5C14.9853 12 17 9.98528 17 7.5V7.5C17 5.01472 14.9853 3 12.5 3H9M4 12V8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M4 12H15.5C17.9853 12 20 14.0147 20 16.5V16.5C20 18.9853 17.9853 21 15.5 21H5.77778C4.79594 21 4 20.2041 4 19.2222V12ZM4 12H12.5C14.9853 12 17 9.98528 17 7.5V7.5C17 5.01472 14.9853 3 12.5 3H5.44444C4.6467 3 4 3.6467 4 4.44444V12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M4 12H15.5C17.9853 12 20 14.0147 20 16.5V16.5C20 18.9853 17.9853 21 15.5 21H5.77778C4.79594 21 4 20.2041 4 19.2222V12ZM4 12H12.5C14.9853 12 17 9.98528 17 7.5V7.5C17 5.01472 14.9853 3 12.5 3H5.44444C4.6467 3 4 3.6467 4 4.44444V12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M18.3284 12.9999C18.6808 13.285 18.9892 13.6222 19.242 13.9999C19.7206 14.7149 19.9998 15.5748 19.9998 16.4999C19.9998 18.9852 17.985 20.9999 15.4998 20.9999H5.77753C4.79569 20.9999 3.99976 20.2039 3.99976 19.2221V4.44432C3.99976 3.64658 4.64646 2.99988 5.4442 2.99988H12.4998C14.985 2.99988 16.9998 5.0146 16.9998 7.49988C16.9998 9.98516 14.985 11.9999 12.4998 11.9999H7.99976"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M4 12H15.5C17.9853 12 20 14.0147 20 16.5V16.5C20 18.9853 17.9853 21 15.5 21H5.77778C4.79594 21 4 20.2041 4 19.2222V12ZM4 12H12.5C14.9853 12 17 9.98528 17 7.5V7.5C17 5.01472 14.9853 3 12.5 3H5.44444C4.6467 3 4 3.6467 4 4.44444V12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M4 12H15.5C17.9853 12 20 14.0147 20 16.5V16.5C20 18.9853 17.9853 21 15.5 21H5.77778C4.79594 21 4 20.2041 4 19.2222V12ZM4 12H12.5C14.9853 12 17 9.98528 17 7.5V7.5C17 5.01472 14.9853 3 12.5 3H5.44444C4.6467 3 4 3.6467 4 4.44444V12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
